module.exports = __webpack_public_path__ + "static/media/student-bg-bg.268ff5a0.jpg";